/**
 * @module app.prospection.common.commonDirective
 */

/**
 * @description Map directive
 * @constructor
 * @module app.prospection.common
 */
function bmMessagesDirective(localStorageService, departementsService, $timeout) {
    function Controller() {
        this.message;
    }
    Controller.prototype.clear = function() {
        this.message = null;
    };

    return {
        restrict: 'E',
        scope: {
            message: '='
        },
        controller: Controller,
        controllerAs: 'vm',
        bindToController: true,
        templateUrl: 'prospection/common/partials/messages.html'
    };
}
bmMessagesDirective.$inject = [];

angular.module('app.prospection.common').directive('bmMessages', bmMessagesDirective);
